export const enabledStubDetailImageConstructor = false
export const enabledSocialImageConstructor = false
export const availableAspectRatios = [1, 0.66, 1.5, 1.9]
